import React from 'react';
import { Router, Route, Routes, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SignIn from './SignIn';
import MainPage from './MainPage';


import CraftCounter from './CraftCounter/CraftCounter';
import Products from './CraftCounter/Products';
import Vendors from "./CraftCounter/Vendors";
import Inventory from "./CraftCounter/Inventory";
import Inwards from "./CraftCounter/Inwards";
import Outwards from "./CraftCounter/Outwards";
import Reportscraft from "./CraftCounter/Reportscraft";



import Plc from "./PLC/plc";



import Payment_gateway from "./Payment_Gateway/Payment_gateway";




import VendingMachine from './Vending_Machine/VendingMachine';


import Rosaf from  './RosaF/Rosaf';
import Teachh from './RosaF/Teachh';
import Opens  from './RosaF/Opens';
import DisplayName from './RosaF/displayname';
import DetailedTime from './RosaF/DetailedTime';
import ReportPage from './RosaF/ReportPage';
import DeletePage from './RosaF/DeletePage';
import Viewedit from './RosaF/Viewedit';
import ViewPage from './RosaF/ViewPage';
import EditPage from './RosaF/EditPage';
import Rosas from  './RosaS/Rosas';
import SetUpp from './RosaS/SetUpp';
import FaceDetection from './RosaS/FaceDetection';
import MotionDetection from './RosaS/MotionDetection';
import RosaSc from './RosaSc/RosaSc';
import Rosap from './RosaP/Rosap'; 

import SetUps from './RosaP/SetUps';
import StartUps from './RosaP/StartUps';
import Reports from './RosaP/Reports';
import Deletes from './RosaP/Deletes';
import ViewsEdits from './RosaP/ViewsEdits';
import Detail from './RosaP/Detail';
import Viewss from './RosaP/Viewss';
import Modify from './RosaP/Modify';

import Rosai from './RosaI/Rosai';
import Distance from './RosaI/Distance';
import Rosad from './RosaD/Rosad';
import Spring from './RosaD/Spring';
import DoughNut from './RosaD/DoughNut';
import Sphere from './RosaD/Sphere';
import Pipe from './RosaD/Pipe';
import Fpipe from './RosaD/FPipe';
import RoundRod from './RosaD/RoundRod';
import HexRod from './RosaD/HexRod';
import Bearing from './RosaD/Bearing';
import Oring from './RosaD/Oring';
import CustomChair from './RosaD/CustomChair';
import SprayNozzel from './RosaD/SprayNozzel';
import SquareCube  from './RosaD/SquareCube';
import HexagonalTube from './RosaD/HexagonalTube';
import PerforatedSheet from './RosaD/PerforatedSheet';
import StepTo2D from './RosaD/StepTo2D';
import Parametricscrew from './RosaD/Parametricscrew';
import Nuts from './RosaD/Nuts';
import RosaAccounting from './RosaAc/RosaAccounting';
import RosaAC from "./RosaAc/RosaAC";
import Screens from "./RosaAc/Screens";
import RecordExpenses from "./RosaAc/RecordExpenses";
import LedgerView from "./RosaAc/LedgerView";
import IncomeStatement from "./RosaAc/IncomeStatement";





import RosaMkt from "./RosaMkt/RosaMkt";
import UnreadMails from "./RosaMkt/UnreadMails";


import Rosag from './RosaG/Rosag';
import Rosag_Sync from './RosaG/Rosag_Sync';
import Rosag_Setup from './RosaG/Rosag_Setup';
import FaceDetectedg from './RosaG/FaceDetectedg';
import Createintroductiong from './RosaG/Createintroductiong';
import Editintroductiong from './RosaG/Editintroductiong';




import ValveCalculation from './RosaD/ValveCalculation';
import PneumaticCircuit from './RosaD/PneumaticCircuit';
import HydraulicPump from './RosaD/HydraulicPump';
import SpurGear from './RosaD/SpurGear';
import SheetMetal from './RosaD/SheetMetal';


import NeoBot_Pizza from './NeoBot_Pizza/NeoBot_Pizza'; 
import NeoBot from './NeoBot/NeoBot';
import Truck from './Truck/NeoBot_truck'; 
import RosaChatgpt from  './RosaChatgpt/RosaChatgpt';
import MainCosmo   from './CosmoAutomation/MainCosmo';
import CosmoAutomation from './CosmoAutomation/CosmoAutomation';
import FingerprintScreen from './CosmoAutomation/FingerprintScreen';
import ShopFloor from './CosmoAutomation/ShopFloor';
import Hydraulics from './CosmoAutomation/Hydraulics';
import Operations from './CosmoAutomation/Operations';




const clientId = '1031823034707-pr466lm24luefv53rtj1dncgjbbb5mmi.apps.googleusercontent.com';

const App = () => {
  return (
    <center>
    <GoogleOAuthProvider clientId={clientId}>
      
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/main" element={<MainPage />} />



          <Route path="/CraftCounter" element={<CraftCounter />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/Vendors" element={<Vendors />} />
          <Route path="/Inventory" element={<Inventory />} />
          <Route path="/Inwards" element={<Inwards />} />
          <Route path="/Outwards" element={<Outwards />} />
          <Route path="/Reportscraft" element={<Reportscraft />} />

       


          <Route path="/plc" element={<Plc />} />


          <Route path="/Rosaf" element={<Rosaf />} />
          <Route path="/Teachh" element={<Teachh />} />
          <Route path="/Opens" element={<Opens />} />
          <Route path="/displayname" element={<DisplayName />} />
          <Route path="/details/:personName" element={<DetailedTime />} />
          <Route path="/report/:personName"  element={<ReportPage />} />
          <Route path="/delete" element={<DeletePage />} />
          <Route path="/Viewedit" element={<Viewedit />} />
          <Route path="/ViewPage" element={<ViewPage />} />
          <Route path="/EditPage" element={<EditPage />} />
          <Route path="/rosas" element={<Rosas />} />
          <Route path="/SetUpp" element={<SetUpp />} />
          <Route path="/FaceDetection" element={<FaceDetection />} />
          <Route path="/MotionDetection" element={<MotionDetection />} />
          <Route path="/rosasc" element={<RosaSc />} />
          <Route path="/rosap" element={<Rosap />} />
          <Route path="/SetUps" element={<SetUps />} />
          <Route path="/StartUps" element={<StartUps />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/Deletes" element={<Deletes />} />
          <Route path="/ViewsEdits" element={<ViewsEdits />} />
          <Route path="/Detail" element={<Detail />} />
          <Route path="/Viewss" element={<Viewss />} />
          <Route path="/Modify" element={<Modify />} />
          <Route path="/rosai" element={<Rosai />} />
          <Route path="/distance" element={<Distance />} />
          <Route path="/rosad" element={<Rosad />} />
          <Route path="/spring" element={<Spring />} />
          <Route path="/doughnut" element={<DoughNut />} />
          <Route path="/sphere" element={<Sphere />} />
          <Route path="/sheetmetal" element={<SheetMetal />} />
          <Route path="/pipe" element={<Pipe />} />
          <Route path="/fpipe" element={<Fpipe />} />
          <Route path="/roundrod" element={<RoundRod />} />
          <Route path="/hexrod" element={<HexRod />} />
          <Route path="/bearing" element={<Bearing />} />
          <Route path="/oring" element={<Oring />} />
          <Route path="/customchair" element={<CustomChair />} />
          <Route path="/spraynozzel" element={<SprayNozzel />} />
          <Route path="/squarecube" element={<SquareCube />} />
          <Route path="/hexagonaltube" element={<HexagonalTube />} />
          <Route path="/PerforatedSheet" element={<PerforatedSheet />} />
          <Route path="/StepTo2D" element={<StepTo2D />} />
          <Route path="/parametricscrew" element={<Parametricscrew />} />
          <Route path="/nuts" element={<Nuts />} />
          <Route path="/rosaaccounting" element={<RosaAccounting />} />
          <Route path="/rosaac" element={<RosaAC />} />
          <Route path="/screens" element={<Screens />} />
          <Route path="/recordexpenses" element={<RecordExpenses />} />
          <Route path ="/ledgerview"   element={<LedgerView />} />
          <Route path ="/incomestatement"   element={<IncomeStatement />} />




         <Route path="/rosamkt" element={<RosaMkt />} />
         <Route path="/unread-mails" element={<UnreadMails />} />



         <Route path="/rosag" element={<Rosag />} />
            <Route path="/face_detectedg" element={<FaceDetectedg />} />
            <Route path="/rosag_sync" element={<Rosag_Sync />} />
            <Route path="/rosag_setup" element={<Rosag_Setup />} />
            <Route path="/createintroductiong" element={<Createintroductiong />} />
            <Route path="/editintroductiong" element={<Editintroductiong />} />





          <Route path="/valvecalculation" element={<ValveCalculation />} />
          <Route path="/pneumaticcircuit" element={<PneumaticCircuit />} />
          <Route path="/hydraulicpump" element={<HydraulicPump />} />
          <Route path="/spurgear" element={<SpurGear />} />
          <Route path="/neobot_pizza" element={<NeoBot_Pizza />} />
          <Route path="/neobot_truck" element={<Truck />} />
          <Route path="/neobot" element={<NeoBot/>} />
          <Route path="/rosachatgpt" element={<RosaChatgpt/>} />
          <Route path="/maincosmo" element={<MainCosmo/>} />
          <Route path="/cosmoautomation" element={<CosmoAutomation/>} />
          <Route path="/fingerprintscreen" element={<FingerprintScreen/>} />
          <Route path="/shopfloor" element={<ShopFloor/>} />
          <Route path="/hydraulics" element={<Hydraulics/>} />
          <Route path="/operations" element={<Operations/>} />




           <Route
    path="/payment-gateway"
    element={<Payment_gateway />}
/>
       
 
            
<Route
  path="/vending-machine"
  element={<VendingMachine />}
/>







        </Routes>
      
    </GoogleOAuthProvider>
    </center>
  );
};

export default App;
